
import * as THREE from "three"


export default class DragHelper {

    constructor( camera , window , is3D ) {

        this._is3D = is3D

        this.debug = false

        this.camera = camera
        this.window = window

        this.raycaster = new THREE.Raycaster()
        //this.raycaster.params.Points.threshold = 0.25

        this.mouse = new THREE.Vector2()
        this.intersects = null
        this.plane = new THREE.Plane()
        this.planeNormal = new THREE.Vector3()
        this.currentIndex = null
        this.planePoint = new THREE.Vector3()
        this.dragging = false

        this.position = {
            x:0,
            y:0,
            z:0
        }

        this.mouse = {

            down: {
                x:0,
                y:0,
                z:0
            },

            delta: {
                x:0,
                y:0,
                z:0
            }

        }

        // save position for dragging
        this.vertices = null
        
    }



    is3D() {

        return this._is3D

    }



    getZ( z ) {

        if ( ! this.is3D() )
            z = 0   // return 0 (only plane x,y)

        return z

    }



    isDebug() {

        return this.debug

    }

    verticeSave(vertices) {

        //console.log(vertices,'** save **')

        this.vertices = vertices

    }


    getVerticeSave() {

        //console.log(this.vertices,'** get **')

        return this.vertices

    }

    mouseDown(x,y,z) {

        console.log( 'mouseDown - delta ' + x + ' ' + y + ' ' + z )

        this.mouse.down = {
            x:x,
            y:y,
            z: this.getZ(z)
        }

    }

    mouseMove( event ) {

        if ( this.isDebug() )
            console.log(
                this.currentIndex,
                this.dragging,
                event,
                '--*--'
            )

        if (this.dragging && this.currentIndex !== null) {

            this.setRaycaster( event )

            this.raycaster.ray.intersectPlane( this.plane, this.planePoint )

            // X Y AXIS ONLY :

            if ( ! this.is3D() )
                this.planePoint.z = 0

            if (this.debug)
            console.log('helper > ', this.currentIndex, this.planePoint.x, this.planePoint.y, this.planePoint.z)

            this.position = {

                x: this.planePoint.x,
                y: this.planePoint.y,
                z: this.getZ( this.planePoint.z )

            }

            if (this.debug)
                console.log( this.getZ( this.planePoint.z ) )

            this.mouse.delta = {
                x: - ( this.mouse.down.x -  event.clientX ),
                y:  ( this.mouse.down.y -  event.clientY ),
                z:  this.getZ( this.mouse.down.z /*- event.clientZ */ )
            }

            //console.log('delta : ' + this.mouse.delta.x +' '+ this.mouse.down.x +' '+ this.planePoint.x +' '+ this.position.x )

            // update geometry

            //geometry.attributes.position.setXYZ(currentIndex, planePoint.x, planePoint.y, planePoint.z)
            //geometry.attributes.position.needsUpdate = true
        }
        //return this
    }

    setIndex(intersects,index) {


        this.intersects = intersects
        this.currentIndex =  index
        this.setPlane( this.intersects[0].point)

        //console.log('helper ' + this.currentIndex,this.intersects[0].point)

        return this

    }


    setPlane(point) {

        this.planeNormal.subVectors(this.camera.position, point).normalize()
        this.plane.setFromNormalAndCoplanarPoint(this.planeNormal, point)
        return this

    }

    setRaycaster(event) {

        this.getMouse(event)
        this.raycaster.setFromCamera( this.mouse, this.camera)
        return this

    }

    getMouse(event) {

        this.mouse.x = (event.clientX / this.window.innerWidth) * 2 - 1
        this.mouse.y = -(event.clientY / this.window.innerHeight) * 2 + 1
        //console.log('helper',this.mouse)
        //return this

    }

}